import React from 'react'
import { TicketHeader } from 'view/shared/ticket'
import { DialogRow } from 'view/components/inputs'
import { DealDetail, DealStatus } from 'api'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

interface DealTicketHeaderProps {
  dealDetail: DealDetail
}

export class DealTicketHeader extends React.Component<DealTicketHeaderProps> {
  render() {
    const { dealDetail } = this.props
    const { deal } = dealDetail

    if (deal.status === DealStatus.CANCELLED) {
      return (
        <TicketHeader>
          <DialogRow horizontalLayout={constants.HorizontalLayout.Center}>
            {Locale.translate(Translation.SC_ORIGINAL_DEAL_CANCELLED)}
          </DialogRow>
        </TicketHeader>
      )
    } else {
      return null
    }
  }
}
